import { CalculationParams } from "./CalculationParams"
import { SearchLocation } from "./SearchLocation"

export class LastSearchedItem {
  originLocation: SearchLocation
  destinationLocation: SearchLocation
  calculationParams: CalculationParams

  constructor(
    originLocation: SearchLocation,
    destinationLocation: SearchLocation,
    calculationParams: CalculationParams
  ) {
    this.originLocation = originLocation
    this.destinationLocation = destinationLocation
    this.calculationParams = calculationParams
  }
}
